export default __webpack_public_path__ + "static/media/view_in_AR_icon.164bf7d0.svg";